export default "__VITE_ASSET__D0I7RJFB__"